var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-5"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('common.page_not_found')))]),_c('div',{staticClass:"mt-5 d-flex flex-row justify-content-center"},[_c('button',{staticClass:"btn btn-primary w-25",on:{"click":function($event){return _vm.back()}}},[_vm._v(_vm._s(_vm.$t('buttons.back')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }